import { Text, Layout, useLocalVariant, Flex } from "@draftkings/arena-web";
import * as React from "react";
import { Reference } from "../../Reference";
import { SportsbookContext } from "../../../contexts";
export const OutrightEventCard = React.memo(function OutrightEventCard(props) {
    const { getIcon } = React.useContext(SportsbookContext);
    const eventName = useLocalVariant("text", {
        $extendFromVariant: "betHeadline",
        root: {
            marginBottom: "14px",
        }
    });
    const references = !props.shortLabel ? [props.formattedStartEventDate] : [props.shortLabel, props.formattedStartEventDate];
    return React.createElement(Layout, { variant: "eventCard", testId: 'event-card' },
        React.createElement(Text, { testId: `event-displayName-${props.eventId}`, variant: eventName }, props.eventDisplayName),
        React.createElement(Flex, { gap: "5px" },
            props.isLive && getIcon("live"),
            React.createElement(Reference, { id: props.eventId, references: references, testId: "event-reference" })));
});
//# sourceMappingURL=OutrightEventCard.js.map